import { z } from "zod";
import { PaginationResponseSchema } from "./pagination";

export const CreatePrizeTypeRequestSchema = z.object({
  name: z.string().min(1, "El nombre es requerido"),
  description: z.string().optional(),
  isActive: z.boolean().optional().default(true),
});

export const UpdatePrizeTypeRequestSchema = CreatePrizeTypeRequestSchema.partial();

export type CreatePrizeTypeRequestDTO = z.infer<typeof CreatePrizeTypeRequestSchema>;
export type UpdatePrizeTypeRequestDTO = z.infer<typeof UpdatePrizeTypeRequestSchema>;

export const PrizeTypeResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type PrizeTypeResponseDTO = z.infer<typeof PrizeTypeResponseSchema>;

export const PrizeTypesPaginatedResponseSchema =
  PaginationResponseSchema(PrizeTypeResponseSchema);
export type PrizeTypesPaginatedResponseDTO = z.infer<
  typeof PrizeTypesPaginatedResponseSchema
>;
